import { PricingTier } from '@upheal/billing/utils/plans';

export const referralDiscountDuration = 3; // months

export const getReferralDiscountedPrice = (monthlyPrice: number) => {
    return Math.ceil(monthlyPrice / 2);
};

export const getDescriptionFirstParagraphPerTier = (): Record<
    PricingTier,
    string
> => {
    return {
        [PricingTier.FREE]: '',
        [PricingTier.STARTER]: 'Everything in Free, and:',
        [PricingTier.PREMIUM]: 'Everything in Starter, and:',
        [PricingTier.UNLIMITED]: 'Everything in Premium, and:',
        [PricingTier.GROUP]: 'Everything in Premium, and:',
        [PricingTier.METERED]: '',
        [PricingTier.ENTERPRISE]: '',
        [PricingTier.TRIAL]: '',
    };
};

export const getDescriptionItemsPerTier = (): Record<
    PricingTier,
    React.ReactNode[]
> => {
    return {
        [PricingTier.FREE]: [
            'Notes from dictated or text summaries',
            'Manually upload session recordings',
            'Upheal video calls',
        ],
        [PricingTier.STARTER]: [
            <strong key="unlimited">Unlimited notes</strong>,
            'All note types',
            'Capture in-person sessions',
            'Template customization',
            'Diagnosis & modalities',
            'Smart Edit for quick adjustments',
            'AI learns your writing style',
        ],
        [PricingTier.PREMIUM]: [
            <strong key="unlimited">Unlimited notes</strong>,
            'Telehealth with AI notes',
            'Treatment Plans with Golden Thread',
            'AI assistant',
            'Compliance Checker',
            'Client self-scheduling',
            'Practice forms',
            'Payments',
        ],
        [PricingTier.UNLIMITED]: [
            'Upheal video calls with seamless AI notes and analytics',
            'Priority support for questions and technical needs',
        ],
        [PricingTier.GROUP]: ['Team management', 'Supervision'],
        [PricingTier.METERED]: [],
        [PricingTier.ENTERPRISE]: [],
        [PricingTier.TRIAL]: [],
    };
};
